export const validateInput = values => {
  let errors = true;
  if (!values) {
    errors = 'blank';
  }
  return errors;
};

export const validateEmail = values => {
  let errors = true;
  if (!values) {
    errors = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values)) {
    errors = 'Invalid email address';
  }
  return errors;
};

export const validateNumber = values => {
  let errors;

  if (!values) {
    errors = 'Required';
  } else if (isNaN(Number(values))) {
    errors = 'Must be a number';
  }
  return errors;
};

export const validateCaptcha = values => {
  let errors = true;
  if (values.length === 0) {
    errors = 'blank';
  } else if (values.length !== 7) {
    errors = 'notmatch';
  }

  return errors;
};
